import React from 'react';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Button from '@material-ui/core/Button';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import AttachFileIcon from '@material-ui/icons/InsertDriveFile';
import ClearIcon from '@material-ui/icons/Clear';
import { useMutation } from '@apollo/react-hooks';

import { gql } from 'apollo-boost';
import Upload from '../Upload/index';
import { MyLink } from '../Locale';

export const createMutation = gql`
  mutation uploadFile($fileField: UploadFileObjectType!, $objectType: String!) {
    uploadFile(fileField: $fileField, objectType: $objectType) {
      ok
      fileObject {
        id
        name
        originalName
        url
        status
      }
    }
  }
`;

const FileItem = ({ name, url, onDelete }) => (
  <ListItem>
    <ListItemIcon>
      <AttachFileIcon />
    </ListItemIcon>
    <ListItemText
      style={{ marginRight: '20px' }}
      primary={
        <MyLink target='_blank' to={url} translate={false}>
          {name}
        </MyLink>
      }
    />
    <ListItemSecondaryAction>
      <IconButton onClick={onDelete}>
        <ClearIcon />
      </IconButton>
    </ListItemSecondaryAction>
  </ListItem>
);

const UploadFiles = ({ files, name, objectType, multiple, onChange }) => {
  const [stateFiles, setFiles] = React.useState(files);
  const [saveFile] = useMutation(createMutation);

  const handleOnChange = async (file) => {
    const { data } = await saveFile({
      variables: {
        fileField: file,
        objectType,
      },
    });
    const { uploadFile } = data;
    if (uploadFile.ok) {
      const newFiles = stateFiles.concat(uploadFile.fileObject);
      setFiles(newFiles);
      onChange({ target: { name, value: newFiles } });
    }
  };

  const handleDelete = (file) => {
    const newFiles = stateFiles.filter((f) => f.id !== file.id);
    setFiles(newFiles);
    onChange({ target: { name, value: newFiles } });
  };

  return (
    <>
      <Upload id='uploadFile' onUpload={handleOnChange} multiple={multiple}>
        <Button
          variant='outlined'
          color='primary'
          component='span'
          size='large'
        >
          Завантажити документи
          <AttachFileIcon style={{ marginLeft: '5px' }} />
        </Button>
      </Upload>
      <Grid container>
        <Grid item>
          <List>
            {stateFiles.map((f) => (
              <FileItem
                key={f.id}
                name={f.originalName}
                url={f.url}
                onDelete={() => handleDelete(f)}
              />
            ))}
          </List>
        </Grid>
      </Grid>
    </>
  );
};

export default UploadFiles;
